<template>
    <v-container>
        <v-row style="height: 100%">
            <v-col cols="4" id="sidebar">
                <h1>Welcome to lighty!</h1>
                <h3>Please sign up/login on the right.</h3>
                <v-img id="logo" src="@/assets/images/logo.png" height="150" contain></v-img>
            </v-col>
            <v-col cols="8">
                <section id="firebaseui-auth-container"></section>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import firebase from "firebase";
import * as firebaseui from "firebaseui"
import "firebaseui/dist/firebaseui.css";

export default {
    data() {
        return {
        };
    },
    components: {
    },
    mounted() 
    {
        var search_path = sessionStorage.getItem('search_query');
        sessionStorage.removeItem('search_query');

        //get the parent_tab_id URL param, if present
        if(search_path!=null)
        {
            const urlParams = new URLSearchParams(search_path);
            var parent_tab_id = urlParams.get('parent_tab_id');
            if(parent_tab_id!=null)
            {
                parent_tab_id = parseInt(parent_tab_id);
                var event = new CustomEvent("send_cross_tab_message", {detail: {'target': 'parent', 'data': {"message": "logged_out"}, 'tab_id': parent_tab_id}});
                window.dispatchEvent(event);
            }
        }

        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) 
        {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var uiConfig = {
            signInSuccessUrl: "/home", // This redirect can be achived by route using callback.
            signInFlow: "popup",
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ]
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    }
};
</script>

<style scoped>
#logo
{
    margin-top: 50%;
}
#sidebar
{
    background-color: #85C1E9;
    height: 100%;
    border-radius: 15px;
    color: black;
}
</style>
